module.exports = __webpack_public_path__ + "img/ic_float_up.98d135a5.svg";